import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/Dashboard/DashboardView.vue";
import { initGuards } from "@/router/guards";
import { useSidebarStore, useUserStore } from "@/stores";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/auth",
      name: "Auth",
      beforeEnter: () => {
        const { handleShrink } = useSidebarStore();
        handleShrink(true);
      },
      meta: {
        hideNavigation: true,
      },
      children: [
        {
          name: "Login",
          path: "login",
          component: () => import("../views/Auth/Login.vue"),
        },
        {
          name: "ForgotPassword",
          path: "sifremi-unuttum",
          component: () => import("../views/Auth/ForgotPassword.vue"),
        },
        {
          name: "CreatePassword",
          path: "sifre-yenile",
          component: () => import("../views/Auth/CreatePassword.vue"),
        },
        {
          path: "logout",
          name: "Logout",
          beforeEnter: async () => {
            const userStore = useUserStore();
            await userStore.logout("/dashboard");
            return false;
          },
          component: () => {},
        },
      ],
    },
    {
      path: "/anasayfa",
      name: "Dashboard",
      component: HomeView,
    },
    {
      path: "/kasalar",
      name: "Banks",
      children: [
        {
          path: "",
          name: "BanksView",
          component: () => import("../views/Banks/BanksView.vue"),
        },
        {
          path: "ekle",
          name: "BankCreate",
          component: () => import("../views/Banks/BankCreate.vue"),
        },
        {
          path: "detay",
          name: "BankDetail",
          component: () => import("../views/Banks/BankDetail.vue"),
        },
      ],
    },
    {
      path: "/kisiler",
      name: "Tenants",
      children: [
        {
          path: "",
          name: "TenantsView",
          component: () => import("../views/Tenants/TenantsView.vue"),
        },
        {
          path: "detay",
          name: "TenantDetail",
          component: () => import("../views/Tenants/TenantDetail.vue"),
        },
      ],
    },
    {
      path: "/magazalar",
      name: "Properties",
      children: [
        {
          path: "",
          name: "PropertiesView",
          component: () => import("../views/Properties/PropertiesView.vue"),
        },
        {
          path: "ekle",
          name: "PropertyCreate",
          component: () => import("../views/Properties/PropertyCreate.vue"),
        },
        {
          path: "detay",
          name: "PropertyDetail",
          component: () => import("../views/Properties/PropertyDetail.vue"),
        },
        {
          path: "kiraci/ekle",
          name: "TenantPropertyCreate",
          component: () => import("../views/Tenants/TenantCreate.vue"),
        },
      ],
    },
    {
      path: "/depolar",
      name: "Stores",
      children: [
        {
          path: "",
          name: "StoresView",
          component: () => import("../views/Stores/StoresView.vue"),
        },
        {
          path: "ekle",
          name: "StoreCreate",
          component: () => import("../views/Stores/StoreCreate.vue"),
        },
        {
          path: "detay",
          name: "StoreDetail",
          component: () => import("../views/Stores/StoreDetail.vue"),
        },
        {
          path: "kiraci/ekle",
          name: "TenantStoreCreate",
          component: () => import("../views/Tenants/TenantCreate.vue"),
        },
      ],
    },
    {
      path: "/yonetim",
      name: "Managements",
      children: [
        {
          path: "",
          name: "TenantRentsView",
          component: () => import("../views/Managements/TenantRentsView.vue"),
        },
      ],
    },
    {
      path: "/",
      redirect: "/anasayfa",
    },
    {
      path: "/:pathMatch(.*)*",
      name: "ErrorView",
      component: () => import("../views/NotFound.vue"),
    },
    {
      path: "/giderler",
      name: "Expenses",
      children: [
        {
          path: "",
          name: "ExpenseView",
          component: () => import("@/views/Expenses/ExpenseView.vue"),
        },
        {
          path: "ekle",
          name: "ExpenseCreate",
          component: () => import("../views/Expenses/ExpenseCreate.vue"),
        },
        {
          path: "detay",
          name: "ExpenseDetail",
          component: () => import("../views/Expenses/ExpenseDetail.vue"),
        },
        {
          path: "detay/alt-giderler/detay",
          name: "SubExpenseDetail",
          component: () => import("../views/Expenses/SubExpenseDetail.vue"),
        },
      ],
    },
    {
      path: "/gelirler",
      name: "Revenues",
      children: [
        {
          path: "",
          name: "RevenueView",
          component: () => import("@/views/Revenues/RevenueView.vue"),
        },
        {
          path: "ekle",
          name: "RevenueCreate",
          component: () => import("../views/Revenues/RevenueCreate.vue"),
        },
        {
          path: "detay",
          name: "RevenueDetail",
          component: () => import("../views/Revenues/RevenueDetail.vue"),
        },
      ],
    },
    {
      path: "/raporlar",
      name: "Reports",
      children: [
        {
          path: "genel",
          name: "ReportsView",
          component: () => import("../views/Reports/ReportsView.vue"),
        },
        {
          path: "kisiler",
          name: "ReportTenantsView",
          component: () => import("../views/Reports/ReportTenantsView.vue"),
        },
        {
          path: "kasalar",
          name: "ReportBanksView",
          component: () => import("../views/Reports/ReportBanksView.vue"),
        },
        {
          path: "giderler",
          name: "ReportExpensesView",
          component: () => import("../views/Reports/ReportExpensesView.vue"),
        },
        {
          path: "gelirler",
          name: "ReportRevenuesView",
          component: () => import("../views/Reports/ReportRevenuesView.vue"),
        },
        {
          path: "ayrilan-kiracilar",
          name: "ReportFormerTenantsView",
          component: () =>
            import("../views/Reports/ReportFormerTenantsView.vue"),
        },
      ],
    },
  ],
});
initGuards(router);
export default router;
